import classNames from "classnames/bind";
import styles from "./ModalDetail.module.css";
import PropTypes from 'prop-types';
import { Button } from "../../../components";
import { Close } from "../../../components/Icons/Icons";
import { useEffect, useRef } from "react";
const cx = classNames.bind(styles);

function ModalDetail({ getShowModal, dataInfo, getSeen }) {
    const refNotification = useRef()
    const handleCheckNotification = () => {
        if (dataInfo?.SEEN === 0) {
            getSeen(dataInfo?.CODE)
        } else {
            getShowModal()
        }
    }

    useEffect(() => {
        const handleCloseOnClickOutSide = (e) => {
            if (e.target === refNotification.current) {
                getShowModal()
            }
        }
        document.addEventListener('click', handleCloseOnClickOutSide)
        return () => { document.removeEventListener('click', handleCloseOnClickOutSide) }
    }, [getShowModal])
    return (
        <div className={cx('modal-info-notification')} ref={refNotification}>
            <div className={cx('info-container')}>
                <div className={cx('header')}>
                    <h1>Chi tiết thông báo</h1>
                    <span className={cx('button-close')} onClick={getShowModal}><Close /></span>
                </div>
                <div className={cx('info-box-content')}>
                    <div className={cx('item-info')}>
                        <p className={cx('label')}>Loại thông báo</p>
                        <p className={cx('content')}>{dataInfo?.NAME}</p>
                    </div>
                    <div className={cx('item-info')}>
                        <p className={cx('label')}>Thông báo</p>
                        <p className={cx('content')}>{dataInfo?.DETAIL}</p>
                    </div>
                    {/* <div className={cx('item-info')}>
                        <p className={cx('label')}>Đối tượng</p>
                        <p className={cx('content')}>{dataInfo?.NAME_CAM}</p>
                    </div> */}
                    <div className={cx('item-info')}>
                        <p className={cx('label')}>Người nhận</p>
                        <p className={cx('content')}>{dataInfo?.RECEIVER}</p>
                    </div>
                    <div className={cx('item-info')}>
                        <p className={cx('label')}>Thời gian</p>
                        <p className={cx('content')}>{dataInfo?.TIME}</p>
                    </div>
                </div>
                <div className={cx("actions", 'bottom')}>
                    <Button
                        onClick={getShowModal}
                        className={cx("btn-close")}
                        title="Đóng"
                    />
                    <Button
                        onClick={handleCheckNotification}
                        className={cx("btn-setting")}
                        title="Đánh dấu đã đọc"
                    />
                </div>
            </div>
        </div>
    )
}

ModalDetail.propTypes = {
    getShowModal: PropTypes.func.isRequired,
    getSeen: PropTypes.func.isRequired,
    dataInfo: PropTypes.object.isRequired
}

export default ModalDetail;